import { render, staticRenderFns } from "./o-carousel-v2.vue?vue&type=template&id=eb01ba48&scoped=true"
import script from "./o-carousel-v2.vue?vue&type=script&lang=js"
export * from "./o-carousel-v2.vue?vue&type=script&lang=js"
import style0 from "./o-carousel-v2.vue?vue&type=style&index=0&id=eb01ba48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb01ba48",
  null
  
)

export default component.exports